<template>
  <div class="details-view">
    <div class="main-contain">
      <el-form class="section" label-position="right" label-width="120px" label-suffix=":">
        <div class="app-main-inner-row" style="flex-direction: column">
          <el-divider content-position="left">{{ $t('SystemDocking.ExportSettings') }}</el-divider>
          <el-form-item label="数据类型">
            <el-radio-group v-model="form.ar">
              <el-radio :label="1">{{ $t('SystemDocking.AccountsReceivableBills') }}</el-radio>
              <el-radio :label="0">{{ $t('SystemDocking.AccountsPayableBills') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="app-main-inner-row" style="flex-direction: column">
          <el-divider content-position="left">{{ $t('SystemDocking.ExportConditions') }}</el-divider>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('SystemDocking.BusinessDate')">
                <el-date-picker v-model="form.businessDate" type="daterange" style="width: 100%" value-format="yyyy-MM-dd" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('SystemDocking.OperationDate')">
                <el-date-picker v-model="form.customDate" type="daterange" style="width: 100%" value-format="yyyy-MM-dd" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('SystemDocking.BillCreationDate')">
                <el-date-picker v-model="form.dateCreated" type="daterange" style="width: 100%" value-format="yyyy-MM-dd" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="form.ar?$t('SystemDocking.BillInvoicingDate'):$t('SystemDocking.BillReceivingDate')">
                <el-date-picker v-model="form.invoiceDate" type="daterange" style="width: 100%" value-format="yyyy-MM-dd" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('SystemDocking.BillVoucherGenerationDate')">
                <el-date-picker v-model="form.voucherDate" type="daterange" style="width: 100%" value-format="yyyy-MM-dd" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('SystemDocking.BillNo')">
                <el-input v-model="form.billingNo" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('SystemDocking.BusinessStatus')">
                <el-select v-model="form.jobState" multiple>
                  <el-option v-for="state in jobState" :key="state.code" :label="state.chineseName" :value="state.code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('SystemDocking.BusinessType')">
                <el-select v-model="form.lob" multiple>
                  <el-option v-for="type in jobType" :key="type.code" :label="type.chineseName" :value="type.code" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('SystemDocking.OperatingBranch')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Office"
                  multiple
                  :default-multiple-value="form.branchId"
                  @parentCallBack="p=>form.branchId=[...p.value]"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item>
                <div style="display: flex;justify-content: space-between">
                  <span class="orange">{{ $t('SystemDocking.ReminderExportedAtOnce1000') }}</span><el-button type="primary" @click="handleExport">{{ $t('SystemDocking.ConfirmExport') }}</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { STATE_OPERATING, STATE_PRE_COMMIT, STATE_COMMITED, STATE_VERIFIED, AE, AI, SE, SI } from '@/class/cargo/model/parameters/SystemConstants.js'
import { exportBill } from '@/api/systemDocking/kef.js'
import { getLoading } from '@/utils/utilBaseElement'
import convertResToBlob from '@/utils/convertResToBlob'
import CargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
export default {
  name: 'TabBatchExportBill',
  components: { CargoAdvanceSelect, CargoOfficeSelect },
  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    return {
      selectTypeNames: TYPE_NAMES,
      jobState: [STATE_OPERATING, STATE_PRE_COMMIT, STATE_COMMITED, STATE_VERIFIED],
      jobType: [
        AE,
        AI,
        SE,
        SI
      ],
      form: {
        businessDate: [today, today],
        customDate: '',
        dateCreated: '',
        invoiceDate: '',
        voucherDate: '',
        billingNo: '',
        branchId: [this.$store.getters.currentOfficeId],
        jobState: [0],
        lob: ['SE'],
        ar: 1
      }
    }
  },
  methods: {
    handleExport() {
      const { businessDate, customDate, dateCreated, invoiceDate, voucherDate, billingNo, branchId, jobState, lob, ar } = this.form
      const params = {
        ar,
        minBusinessDate: businessDate ? new Date(businessDate[0] + ' 00:00:00').getTime() : 0,
        maxBusinessDate: businessDate ? new Date(businessDate[1] + ' 23:59:59').getTime() : 0,
        minCustomDate: customDate ? new Date(customDate[0] + ' 00:00:00').getTime() : 0,
        maxCustomDate: customDate ? new Date(customDate[1] + ' 23:59:59').getTime() : 0,
        minDateCreated: dateCreated ? new Date(dateCreated[0] + ' 00:00:00').getTime() : 0,
        maxDateCreated: dateCreated ? new Date(dateCreated[1] + ' 23:59:59').getTime() : 0,
        minInvoiceDate: invoiceDate ? new Date(invoiceDate[0] + ' 00:00:00').getTime() : 0,
        maxInvoiceDate: invoiceDate ? new Date(invoiceDate[1] + ' 23:59:59').getTime() : 0,
        minVoucherDate: voucherDate ? new Date(voucherDate[0] + ' 00:00:00').getTime() : 0,
        maxVoucherDate: voucherDate ? new Date(voucherDate[1] + ' 23:59:59').getTime() : 0,
        jobState: jobState.join(','),
        lob: lob.join(','),
        billingNo: billingNo,
        branchId: branchId.join(','),
        sessionId: this.$store.getters.token
      }
      this.startExportBill(params)
    },
    startExportBill(params) {
      this.loading = getLoading()
      exportBill(params).then(res => {
        convertResToBlob(res)
      }).then(() => {
        this.$message.success(this.$t('SystemDocking.ExportSuccessful'))
      }).finally(() => {
        if (this.loading) {
          this.loading.close()
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
